import { type BrowserEmbedder, type BrowserEmbedSettings } from '../browser/browser-embedder'
import { initImmediateOrOnDomReady } from './init'
import { installGlobally } from './install'
import { directStrategyPlugin } from '../plugins/direct-embed-strategy'
import { loadSettings, loadEmbedder, logger } from '@source-digital/embed-core'
import { version } from '../../package.json'
import { GLOBAL } from '../config'

export { type BrowserEmbedSettings, type BrowserEmbedder }

function dispatchReadyEvent (settings: Partial<BrowserEmbedSettings>): void {
  const globalName: string = settings.global ?? GLOBAL
  // @ts-expect-error - globalName is a string
  const event = new CustomEvent('SourceEmbedsLoaded', { detail: { global: globalName, SourceEmbeds: window[globalName] } })
  document.dispatchEvent(event)
}

(async () => {
  const settings = await loadSettings<Partial<BrowserEmbedSettings>>()
  if (settings.version != null && settings.version !== version) {
    logger.warn(`Requested version ${settings.version} does not match current version ${version}, interrupting initialization and loading requested version.`)
    // stop processing this embedder setup and load the requested version
    await loadEmbedder<BrowserEmbedder, Partial<BrowserEmbedSettings>>({
      version: settings.version,
      settings,
      globalName: settings.global ?? GLOBAL
    })
    return
  }

  settings.hooks = settings.hooks ?? []
  settings.hooks.push(directStrategyPlugin)

  const manager: BrowserEmbedder = installGlobally(settings)
  dispatchReadyEvent(settings)

  if (settings.byUrl === true || settings.byJsonElement != null) {
    initImmediateOrOnDomReady(manager, settings)
  }
})().catch(err => {
  logger.error('Initialization failed.', err)
})
